import React from "react";
import { firebaseAuthUI } from "../components/Firebase";

import "firebaseui/dist/firebaseui.css";

const LoginPage = props => {
  React.useEffect(() => {
    firebaseAuthUI();
  }, []);

  return (
    <div>
      <div className="container-fluid">
        <div className="row">
          <div className="col-6 login-left-panel"></div>

          <div className="col-6 login-right-panel">
            <button
              className="login-close-button"
              //onClick={() => (window.location.href = window.location.href)}
            >
              X
            </button>

            <div className="mb-5" style={{ fontSize: "30px" }}>
              登入
            </div>

            <form action="/" method="post">
              <input
                className="mb-3"
                type="text"
                name="email"
                placeholder="請輸入信箱"
              ></input>
              <br />

              <input
                className="mb-3"
                type="password"
                name="password"
                placeholder="請輸入密碼"
              ></input>
              <br />

              <div className="d-flex justify-content-center">
                <input
                  className="login-button"
                  type="submit"
                  value="登入"
                ></input>
              </div>
            </form>

            <div className="my-5 d-flex align-items-center">
              <div
                className="mx-3"
                style={{ width: 50, height: 1, backgroundColor: "gray" }}
              />
              <div>或</div>
              <div
                className="mx-3"
                style={{ width: 50, height: 1, backgroundColor: "gray" }}
              />
            </div>

            <div id="firebaseui-auth-container" />
          </div>
        </div>
      </div>
    </div>
  );
};

export { LoginPage };
